import React from "react"

import { Wallet } from "./images/Wallet"
import { PercentagesBig } from "./images/PercentagesBig"

export const variantConfig = {
  download: [
    {
      title: (
        <>
          Удобная рассрочка*
          <br />
          равными частями
        </>
      ),
      description: <>Разделите стоимость покупки на&nbsp;комфортные платежи</>,
      Icon: Wallet,
      alt: "деньги",
    },
    {
      title: "Кэшбэк до 10%",
      description: <>Экономьте на каждой покупке</>,
    },
    {
      title: (
        <>
          Лимит до 500 000 ₽ <br /> на ваши покупки
        </>
      ),
      description: <>Больше возможностей для ваших желаний</>,
    },
    {
      title: "До +5% к ставке",
      description: <>Любых вкладов Совкомбанка</>,
      Icon: PercentagesBig,
      alt: "деньги",
      buttonText: "Оформить",
    },
  ],
}
